import { getLocale } from "../runtime";

const sv_addedtocart = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tillagd i kundvagn`
};

const addedtocart = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_addedtocart(inputs)
	return "addedToCart";
};

export { addedtocart as "addedToCart" };